import api from '../helpers/api'

export const getApiKeys = () => api.get(`/api-keys`)
export const saveApiKey = (key: any) => api.post(`/api-keys`, key)
export const deleteApiKey = (id: number) => api.delete(`/api-keys/${id}`)
